<template>
    <div class="w-[20%] bg-white border border-[#e2e2e2] py-5  mt-10  cursor-pointer ">
        <!-- En-tête avec titre -->
        <div class="mb-4 px-5">
            <h3 class="text-lg text-center text-[#2A4493] font-semibold leading-tight">{{ title }}</h3>
        </div>

        <!-- Contenu principal -->
        <div class="space-y-3">
            <!-- Date -->
            <div class="px-5 py-2  border-b border-[#e2e2e2]">
                <div class="flex items-start gap-2 border-bottom-[#2A4493]">
                    <div class="text-amber-700 mt-0.5 flex-shrink-0">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                            <line x1="16" y1="2" x2="16" y2="6"/>
                            <line x1="8" y1="2" x2="8" y2="6"/>
                            <line x1="3" y1="10" x2="21" y2="10"/>
                        </svg>
                    </div>
                    <span class="text-sm text-gray-600 leading-relaxed">{{ formattedDate }}</span>
                </div>
            </div>


            <!-- Lieu -->
            <div class="px-5 py-2 border-b border-[#e2e2e2]">
                <div class="flex items-start gap-2 border-bottom-[#2A4493]">
                    <div class="text-amber-700 mt-0.5 flex-shrink-0">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                            <circle cx="12" cy="10" r="3"/>
                        </svg>
                    </div>
                    <div class="flex-1">
                        <div class="text-sm font-medium text-gray-600 mb-0.5">{{ location }}</div>
                    </div>
                </div>
            </div>


            <!-- Horaires -->
            <div class="ml-6 space-y-1">
                <div  class="text-sm text-gray-600 leading-relaxed">
                    à {{ formatTime }}
                </div>
            </div>
        </div>

        <!-- Slot pour contenu additionnel -->
        <div v-if="$slots.default" class="mt-4 pt-4 border-t border-amber-200">
            <slot></slot>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue'

// Props du composant
const props = defineProps({
    title: {
        type: String,
        required: true
    },
    date: {
        type: [String, Date],
        required: true
    },
    location: {
        type: String,
        required: true,
    },
    dateFormat: {
        type: String,
        default: 'dddd d MMMM yyyy'
    }
})

// Formatage de la date
const formattedDate = computed(() => {
    if (!props.date) return ''

    const date = new Date(props.date)
    const options = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    }

    return date.toLocaleDateString('fr-FR', options)
})
const formatTime = computed(() => {
    if (!props.date) return ''
    return new Date(props.date).toLocaleTimeString('fr-FR', {
        hour: '2-digit',
        minute: '2-digit'
    })
})

// Émissions d'événements (optionnel)
const emit = defineEmits(['click', 'favorite'])

// Méthodes
const handleClick = () => {
    emit('click')
}
</script>
